import React from "react";
import Alerts from "./components/Alerts";
import { CareRecipients } from "./components/CareRecipients";

export function AdminCareRecipientListPage() {
    return (
        <div className={"admin_care_recipient_list_page"}>
            <div className={"header"}>
                利用者一覧
            </div>
            <div>
                {/* アラート一覧 */}
                <Alerts />
                {/* 利用者一覧 */}
                <CareRecipients />
            </div>
        </div>
    );
}
